// Constants and URL builders for the shoot dispatch page. Kept apart from the
// markup so the Google Form entry ids and the phone/SMS handling are testable
// and can be corrected in one place.

export const SUPPORT_CONTACT = {
    name: "Devin",
    phone: "5616431617",
};

export const SHOOT_GUIDE_URL = "https://www.ectcreators.com/ect-shoot-guide.html";
export const TUTORIAL_VIDEO_URL = "https://www.youtube.com/watch?v=gpps5Dsmfyg";

const CANCEL_FORM = "https://docs.google.com/forms/d/e/1FAIpQLSdIrejF2MZaCgifJ9TVH1wpNPEEejV0Pqz3JZAsjvbWSaMEfg/viewform";
const CANCEL_VIN_ENTRY = "entry.1897447249";

const prefilledForm = (formUrl, entryId, vin) =>
    `${formUrl}?usp=pp_url&${entryId}=${encodeURIComponent(vin || "")}`;

export const cancelShootFormUrl = (vin) =>
    prefilledForm(CANCEL_FORM, CANCEL_VIN_ENTRY, vin);

// Strips formatting and adds the US country code, which tel: and sms: need.
export const dialable = (phone) => {
    const digits = String(phone == null ? "" : phone).replace(/\D/g, "");
    if (!digits) {
        return null;
    }
    return digits.length === 11 && digits.startsWith("1") ? `+${digits}` : `+1${digits}`;
};

export const telHref = (phone) => {
    const number = dialable(phone);
    return number ? `tel:${number}` : null;
};

// NOTE: `&body=` rather than the RFC's `?body=`. This is what the approved
// mockup shipped and what has been used in the field, and iOS Messages accepts
// it. Android is the risk — if photographers on Android report the message body
// arriving empty, `?body=` is the fix.
export const smsHref = (phone, message) => {
    const number = dialable(phone);
    return number ? `sms:${number}&body=${encodeURIComponent(message)}` : null;
};

export const introMessage = (vehicleShortName) =>
    `Hi, this is [your name]. I'll be photographing your ${vehicleShortName || "vehicle"} for Exotic Car Trader. ` +
    `Please shoot me a call or text about setting up a time and place that works for you. Thanks!`;

// The shoots API returns the customer's number as `customerPhone`. Kept as a
// function so the empty-value handling lives in one place: a blank string must
// read as "no number" so the call and text buttons render disabled rather than
// producing a dead tel: link.
export const customerPhoneOf = (shoot) => {
    if (!shoot || shoot.customerPhone == null) {
        return null;
    }
    return String(shoot.customerPhone).trim() === "" ? null : shoot.customerPhone;
};

// "James Shelton" -> "JS". Falls back to a single letter, then to a dash.
export const initialsOf = (name) => {
    const words = String(name || "").trim().split(/\s+/).filter(Boolean);
    if (!words.length) {
        return "–";
    }
    return words.slice(0, 2).map((w) => w[0].toUpperCase()).join("");
};
